import {
  UPDATE_INTEGRATION_DATA,
  UPDATE_INTEGRATION_DATA_SUCCESS,
  UPDATE_INTEGRATION_DATA_ERROR,
  UPDATE_INTEGRATION_DATA_EMPTY,
} from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateIntegrationData = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_INTEGRATION_DATA:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_INTEGRATION_DATA_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_INTEGRATION_DATA_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_INTEGRATION_DATA_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateIntegrationData;
